import React, { useState, useEffect, useContext } from 'react';
import { Card, Table, Button, Form, Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { FiSearch, FiFilter, FiPlus, FiMapPin } from 'react-icons/fi';

import { AppContext } from '../AppContext';
import { tre } from '../trebus';

export default function Stops() {
    const context = useContext(AppContext);
    const navigate = useNavigate();
    const [stops, setStops] = useState([]);
    const [filteredStops, setFilteredStops] = useState([]);
    const [searchString, setSearchString] = useState('');
    const [isLoading, setIsLoading] = useState(true);

    // Load stops
    const loadStops = () => {
        setIsLoading(true);
        tre.api('GET', `/companies/${context.idCompany}/stops`, {
            context: context,
            success: (r) => {
                setStops(r);
                setIsLoading(false);
            },
            error: () => setIsLoading(false)
        });
    };

    useEffect(() => {
        loadStops();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Filter stops when search changes
    useEffect(() => {
        let filtered = stops;

        if (searchString) {
            const search = searchString.toLowerCase();
            filtered = filtered.filter(s =>
                s.name && s.name.toLowerCase().includes(search)
            );
        }

        setFilteredStops(filtered);
    }, [stops, searchString]);

    const onSelect = (stop) => {
        navigate(`/stops/${stop.id}`);
    };

    // -----| Render |-----
    return (
        <div className="container py-4">
            {/* Header */}
            <div className="d-flex align-items-center justify-content-between mb-4">
                <div>
                    <h4 className="mb-1" style={{ color: '#202124', fontWeight: 500 }}>
                        <FiMapPin className="me-2" style={{ color: '#1a73e8' }} />
                        Paradas
                    </h4>
                    <p className="text-muted mb-0" style={{ fontSize: '14px' }}>
                        {filteredStops.length} paradas en total
                    </p>
                </div>
                <Button
                    variant="primary"
                    onClick={() => navigate('/stops/create')}
                >
                    <FiPlus className="me-2" />
                    Nueva Parada
                </Button>
            </div>

            {/* Filters - Inline style */}
            <div className="d-flex flex-wrap align-items-center gap-3 mb-4 p-3" style={{ backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
                {/* Search */}
                <div className="position-relative" style={{ minWidth: '280px', flex: 1, maxWidth: '400px' }}>
                    <FiSearch
                        className="position-absolute"
                        style={{ left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#5f6368' }}
                    />
                    <Form.Control
                        type="text"
                        placeholder="Buscar por nombre..."
                        value={searchString}
                        onChange={(e) => setSearchString(e.target.value)}
                        style={{ paddingLeft: '38px', backgroundColor: 'white' }}
                    />
                </div>

                {/* Clear filters - only show if filters active */}
                {searchString && (
                    <Button
                        variant="link"
                        size="sm"
                        onClick={() => setSearchString('')}
                        style={{ color: '#ea4335', textDecoration: 'none' }}
                    >
                        <FiFilter className="me-1" /> Limpiar
                    </Button>
                )}
            </div>

            {/* Table Card */}
            <Card>
                {/* Top Info */}
                {!isLoading && filteredStops.length > 0 && (
                    <Card.Header className="d-flex justify-content-between align-items-center py-3" style={{ backgroundColor: '#f8f9fa' }}>
                        <span style={{ fontSize: '14px', color: '#5f6368' }}>
                            <strong style={{ color: '#202124' }}>{filteredStops.length}</strong> paradas
                        </span>
                    </Card.Header>
                )}

                <Card.Body className="p-0">
                    {isLoading ? (
                        <div className="text-center py-5">
                            <Spinner animation="border" style={{ color: '#1a73e8' }} />
                            <p className="mt-3 text-muted">Cargando paradas...</p>
                        </div>
                    ) : filteredStops.length > 0 ? (
                        <Table hover responsive className="mb-0">
                            <thead style={{ backgroundColor: '#f8f9fa' }}>
                                <tr>
                                    <th className="py-3 px-3" style={{ fontWeight: 500, color: '#5f6368', fontSize: '13px' }}>NOMBRE</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredStops.map((stop) => (
                                    <tr
                                        key={stop.id}
                                        onClick={() => onSelect(stop)}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <td className="py-3 px-3">
                                            <div className="d-flex align-items-center">
                                                <div
                                                    className="d-flex align-items-center justify-content-center rounded-circle me-3"
                                                    style={{
                                                        width: '36px',
                                                        height: '36px',
                                                        backgroundColor: '#e8f0fe',
                                                        color: '#1a73e8'
                                                    }}
                                                >
                                                    <FiMapPin size={18} />
                                                </div>
                                                <span style={{ color: '#202124', fontWeight: 500 }}>
                                                    {stop.name || '-'}
                                                </span>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    ) : (
                        <div className="text-center py-5">
                            <FiMapPin size={48} className="mb-3" style={{ color: '#dadce0' }} />
                            <p className="text-muted">No se encontraron paradas</p>
                        </div>
                    )}
                </Card.Body>
            </Card>
        </div>
    );
}
